<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6" v-if="propAdd=='tambah'">Tambah Pengguna</v-card-title>
				<v-card-title class="text-h6" v-else>Edit Pengguna</v-card-title>
				<v-card-text class="pb-0">
					<v-row>
						<v-col cols="12" sm="12" md="6" class="right-shadow">
							<v-row>
								<v-col cols="12" class="text-center" v-if="image">
									<v-hover v-slot:default="{ hover }">
										<v-avatar color="grey" size="100">
											<img class="avatar" :src="image">
											<v-expand-transition v-if="false">
												<div v-if="hover" class="d-flex transition-fast-in-fast-out primary v-card--reveal white--text" style="height: 100%;">
													<v-file-input dark color="white" prepend-icon="mdi-camera" hide-input hide-details class="icon-upload-avatar">
														<!-- <v-icon>mdi-camera</v-icon> -->
													</v-file-input>
												</div>
											</v-expand-transition>
										</v-avatar>
									</v-hover>
								</v-col>
								<v-col cols="12" sm="6" md="6" v-if="propAdd=='tambah'" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.username = ''" :error-messages="konfirmResponse.username" v-model="paramAdd.username" label="Username" hint="Username minimal 6 karakter"></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="pb-0">
									<v-autocomplete class="text-capitalize" outlined dense @focus="() => konfirmResponse.type = ''" :error-messages="konfirmResponse.type" v-model="paramAdd.type" :items="OptionType" item-text="type_name" item-value="type_name" label="Tipe Akun" no-data-text="Tidak ada data yang sesuai">
										<template v-slot:item="{item}">
											<div class="text-capitalize">{{item.type_name}}</div>
										</template>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" v-if="propAdd=='tambah'" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.password = ''" :error-messages="konfirmResponse.password" v-model="paramAdd.password" label="Kata Sandi" hint="Kata Sandi minimal 6 karakter" type="password"></v-text-field>
								</v-col>
								<v-col cols="12" v-if="propAdd=='tambah'" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.repassword = ''" :error-messages="konfirmResponse.repassword" v-model="paramAdd.repassword" label="Ulangi Kata Sandi" type="password"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.name = ''" :error-messages="konfirmResponse.name" v-model="paramAdd.name" label="Nama"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.email = ''" :error-messages="konfirmResponse.email" v-model="paramAdd.email" label="Email"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense @keypress="onlyNumber" @paste.prevent  @focus="() => konfirmResponse.mobilephone = ''" :error-messages="konfirmResponse.mobilephone" v-model="paramAdd.mobilephone" label="No Handphone"></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="pb-0" v-if="warehouse">
									<v-autocomplete outlined dense @focus="() => konfirmResponse.warehouse_id = ''" :error-messages="konfirmResponse.warehouse_id" v-model="paramAdd.warehouse_id" :items="OptionWarehouse" item-text="warehouse_name" item-value="warehouse_id" label="Warehouse" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="12" md="6" class="pt-0">
							<div class="text-center text-h6 pb-1">Hak Akses Menu</div>
							<div class="menu-access">
								<v-treeview :selectable="paramAdd.type == 'administrator'" v-model="selectedMenu" item-key="menu_id" item-children="menu_array" return-object item-text="menu_name" multiple-active open-on-click :items="arrayMenu" selected-color="primary"></v-treeview>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal()">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			page: 1,
			limit: "10",
			hak: [],
			paramAdd: {
				username: '',
				password: '',
				repassword: '',
				name : '',
				email : '',
				mobilephone : '',
				warehouse_id : '',
				type : '',
				privilege : '',
			},
			selectedMenu: [],
			image: '',
		}
	},
	props: {
		value: Boolean,
		warehouse: Boolean,
		propAdd: String,
		edit: String,
		val: Object,
		filter: Object,
	},
	computed: {
		...mapState('userList', ['konfirmResponse', 'responSukses', 'OptionWarehouse', 'OptionType']),
		...mapState('menuWH', ['listMenu']),

		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		},
		arrayMenu(){
			let menu = [];
			if (this.paramAdd.type == 'superuser') {
				menu = this.listMenu
			} else {
				menu = this.listMenu.filter( el => {
					return el.menu_name !== "Pengguna"
				})
				menu = menu.map( el => {
					if (el.menu_name == 'Dashboard') {
						el.menu_array.map( element => {
							if (element.menu_name == 'Dashboard Warehouse') {
								element.disabled = true
							}
							return element
						})
					}
					return el
				})
			}
			return menu
		}
	},
	methods: {
		...mapActions('userList', ['getUser', 'getUserAll', 'add', 'update', 'addAll', 'updateAll', 'getWarehouseOption', 'getTypeOption']),
		...mapMutations('userList', ['konfirmasiSukses']),
		...mapMutations(['setOverlay']),

		batal() {
			this.dialog = false
			this.konfirmResponse.username = ''
			this.konfirmResponse.password = ''
			this.konfirmResponse.name = ''
			this.konfirmResponse.email = ''
			this.konfirmResponse.mobilephone = ''
			this.konfirmResponse.type = ''
			this.konfirmResponse.warehouse_id = ''
		},
		async simpan() {
			await this.setOverlay(true)
			this.paramAdd.privilege = await JSON.stringify(this.selectedMenu)
			if(this.paramAdd) {
				if(this.propAdd == 'tambah') {
					if (this.warehouse) {
						await this.addAll(this.paramAdd).then( () => {
							if(this.responSukses.code == 200) {
								this.getUserAll(this.queryString(this.filter))
								this.dialog = false
								this.reset()
							} else {
								this.dialog = true
							}
						})
					} else {
						await this.add(this.paramAdd).then( () => {
							if(this.responSukses.code == 200) {
								this.getUser(this.queryString(this.filter))
								this.dialog = false
								this.reset()
							} else {
								this.dialog = true
							}
						})
					}
				} else {
					if (this.warehouse) {
						await this.updateAll(this.paramAdd).then( () => {
							if(this.responSukses.code == 200) {
								this.getUserAll(this.queryString(this.filter))
								this.dialog = false
								this.reset()
							} else {
								this.dialog = true
							}
						})
					} else {
						await this.update(this.paramAdd).then( () => {
							if(this.responSukses.code == 200) {
								this.getUser(this.queryString(this.filter))
								this.dialog = false
								this.reset()
							} else {
								this.dialog = true
							}
						})
					}
				}
			}
			await this.setOverlay(false)
		},
		reset () {
			this.konfirmasiSukses('')
			this.selectedMenu = [{
				"menu_id": "53",
				"menu_name": "Dashboard Warehouse",
				"menu_icon": "",
				"menu_end_point": "/",
				"menu_sort": "1",
				"menu_parent": "4",
				"menu_slug": "dashboard"
			}]
			this.paramAdd.username = ''
			this.paramAdd.password = ''
			this.paramAdd.name = ''
			this.paramAdd.email = ''
			this.paramAdd.mobilephone = ''
			this.paramAdd.warehouse_id = ''
			this.paramAdd.type = ''
			this.paramAdd.privilege = ''
			this.hak = []
			this.konfirmResponse.username = ''
			this.konfirmResponse.password = ''
			this.konfirmResponse.name = ''
			this.konfirmResponse.email = ''
			this.konfirmResponse.mobilephone = ''
			this.konfirmResponse.type = ''
			this.konfirmResponse.warehouse_id = ''
			this.image = ''
		}
	},
	watch: {
		val () {
			if (Object.keys(this.val).length > 0) {
				var user_privilege =  JSON.parse(this.val.user_privilege)
				this.selectedMenu = [... new Set([... user_privilege, {
					"disabled": true,
					"menu_id": "53",
					"menu_name": "Dashboard Warehouse",
					"menu_icon": "",
					"menu_end_point": "/",
					"menu_sort": "1",
					"menu_parent": "4",
					"menu_slug": "dashboard"
				}])]
				this.paramAdd.id = this.val.user_id
				this.paramAdd.name = this.val.user_name
				this.paramAdd.email = this.val.user_email
				this.paramAdd.mobilephone = this.val.user_mobilephone
				this.paramAdd.warehouse_id = this.val.user_warehouse_id
				this.paramAdd.type = this.val.user_type
				this.image = this.val.user_image
			} else {
				this.reset()
			}
		}
	},
	created() {
		this.getTypeOption()
	}
}
</script>
